import { loadStripe } from '@stripe/stripe-js'

const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY
  ? process.env.REACT_APP_STRIPE_KEY
  : 'pk_live_A7OGxXevMW3QCTXn44LeU0KG'

export default loadStripe(STRIPE_KEY)
